import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-auth-modal',
  templateUrl: './auth-modal.component.html',
  styleUrls: ['./auth-modal.component.scss']
})
export class AuthModalComponent implements OnInit {
  visible = false;
  registerVisible = false;
  @Output() close = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
    setTimeout(() => {
      this.visible = true;
    }, 0);
  }

}
